export default "__VITE_ASSET__GvoQyrHS__"